var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('clip-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": 'rgb(93, 197, 150)',
      "size": "56px"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "slot-content"
  }, [(_vm.categoriesObjects.length > 0) ? _c('v-select', {
    attrs: {
      "label": "des",
      "options": _vm.categoriesObjects,
      "categoryModel": true,
      "placeholder": _vm.$Jed.firstUpperTranslate('select a %1$s from the list below', null, {
        key: 'category'
      }, 'female'),
      "selectStyle": {
        'background-color': 'white',
        'border-radius': '4px'
      },
      "tagStyle": {
        'background-color': '#5897fb',
        color: 'white',
        padding: '3px'
      },
      "menuStyle": {
        position: 'relative',
        'max-height': '150px'
      },
      "activeStyle": {
        'background-color': '#5897fb',
        color: 'white'
      },
      "highStyle": {
        'background-color': '#ccc',
        color: 'white'
      }
    },
    model: {
      value: (_vm.categoria),
      callback: function($$v) {
        _vm.categoria = $$v
      },
      expression: "categoria"
    }
  }) : _c('label', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('A problem occurred in loading %1$s', null, {
    key: 'category',
    n: 2
  }, 'female')))]), _c('br'), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "label": "des",
      "options": _vm.models,
      "placeholder": _vm.$Jed.firstUpperTranslate('select a %1$s from the list below', null, {
        key: 'model'
      }, 'male'),
      "selectStyle": {
        'background-color': 'white',
        'border-radius': '4px'
      },
      "tagStyle": {
        'background-color': '#5897fb',
        color: 'white',
        padding: '3px'
      },
      "menuStyle": {
        position: 'relative',
        'max-height': '150px'
      },
      "activeStyle": {
        'background-color': '#5897fb',
        color: 'white'
      },
      "highStyle": {
        'background-color': '#ccc',
        color: 'white'
      }
    },
    model: {
      value: (_vm.modello),
      callback: function($$v) {
        _vm.modello = $$v
      },
      expression: "modello"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v("Logout")]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), (_vm.step7) ? _c('button', {
    staticClass: "btn btn-primary-default",
    attrs: {
      "disabled": _vm.modello == null
    },
    on: {
      "click": _vm.forward
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)))]) : _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "disabled": _vm.modello == null
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('load', null)))])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b62eb6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/SelezioneModello.vue
// module id = 1504
// module chunks = 1